// Module-level (non-reactive) tracker of the currently open chat room.
// Realtime handlers only READ it at event time to decide e.g. whether the
// global hook should play a sound — no component re-renders on change, so a
// Zustand store would be overkill.

let activeRoomId: string | null = null;

export function setActiveChatRoom(roomId: string | null): void {
  activeRoomId = roomId;
  // Keep the service worker in sync so it can suppress push notifications
  // only for the room the user is currently viewing, not for all rooms.
  if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: "SET_ACTIVE_ROOM",
      roomId,
    });
  }
}

export function getActiveChatRoom(): string | null {
  return activeRoomId;
}
